import ExternalCustomerLookupStatus from 'models/external_customer_lookup_status';
import requestCustomerExtension from './request_customer_extension';
import LookupCustomer from './lookup_customer';
import qconsole from 'scripts/lib/qconsole';

export default class ExternalCustomerLookupStatusGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  get suggestionsStore() {
    let currentLocation = this.context.stores.currentLocation.get();
    return (
      currentLocation.customerId &&
      this.context.stores.customers.storesFor(currentLocation.customerId).externalLookupSuggestions
    );
  }

  onFetchSuccess(dto) {
    this.handleEntity(dto);
  }

  onBroadcast(dto) {
    this.handleEntity(dto);
  }

  handleEntity(externalCustomerProfileStatus) {
    this.context.stores.externalCustomerLookupStatus.resetLoading();
    this.context.stores.externalCustomerLookupStatus.set(
      ExternalCustomerLookupStatus.fromJs(externalCustomerProfileStatus)
    );

    const currentLocation = this.context.stores.currentLocation.get();
    const suggestionsStore = this.suggestionsStore;
    const existingLookupSuggestions = suggestionsStore && (suggestionsStore.getPending() || suggestionsStore.get());
    if (currentLocation.customerId && !existingLookupSuggestions) {
      this.context.executeAction(LookupCustomer, currentLocation.customerId);
    }
    if (currentLocation.customerId && !currentLocation.isCustomerExtensionPending) {
      requestCustomerExtension(this.context, currentLocation.customerId);
    }
  }

  onFetchError(error) {
    qconsole.log(`Unexpected error requesting external customer lookup status ${JSON.stringify(error)}`);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/external_customer_lookup/external_customer_lookup_status_gateway_observer.js